import { getHttpClient } from '@eo/shared';

import type { StaffMe } from './types';

const api = () => getHttpClient('api');

export async function fetchMe(): Promise<StaffMe> {
  const res = await api().get<{ user: StaffMe }>('/api/v1/cfo/me');
  return res.data.user;
}

export async function updateName(name: string): Promise<StaffMe> {
  const res = await api().patch<{ user: StaffMe }>('/api/v1/cfo/me', { name });
  return res.data.user;
}
